import { render, staticRenderFns } from "./SEOContentAccordion.vue?vue&type=template&id=dc1162dc&lang=pug&"
import script from "./SEOContentAccordion.vue?vue&type=script&lang=js&"
export * from "./SEOContentAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SEOContentAccordion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc1162dc')) {
      api.createRecord('dc1162dc', component.options)
    } else {
      api.reload('dc1162dc', component.options)
    }
    module.hot.accept("./SEOContentAccordion.vue?vue&type=template&id=dc1162dc&lang=pug&", function () {
      api.rerender('dc1162dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/SEOContentAccordion.vue"
export default component.exports